import { Lightbulb } from 'lucide-react';

interface InlineCoachHintProps {
  message: string;
}

export const InlineCoachHint = ({ message }: InlineCoachHintProps) => (
  <div className="flex items-center gap-1.5 mt-1 ml-7">
    <Lightbulb className="w-3 h-3 text-amber-500 shrink-0" />
    <span className="text-xs text-muted-foreground/80 italic">{message}</span>
  </div>
);
